export const apiActionType = {
  API_START: "api_start",
  API_STOP: "api_stop",
  API_ERROR: "api_error",
};
